import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { DottedDropdownAction } from '../dotted-dropdown/dotted-dropdown.component';
import { first, firstValueFrom } from 'rxjs';
import { LocalStorageService } from '../lib/local-storage.service';
import { TranslateService } from '@ngx-translate/core';
import { EmployeeUser } from '../model/employee';
import { SupportApiService } from '../apis/support-api.service';
import { Common } from '../lib/common-methods';
import { Store } from '@ngrx/store';
import * as AppActions from '../store/actions/app.actions';


/* TODO:
  ✅ Dont allow ' and " chatractes
  ✅ Two lines at list
  ✅ Change password
  ✅ password boxes: plain text
  ✅ ManageUsers permission
  ✅ Send token back
  ✅ Rename to Users
  ✅ Call sessiοn delete on password change & on user delete
  ✅ English translations
*/

@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.scss']
})
export class EmployeeListComponent implements OnInit {

  @ViewChild('modal') modal!: ModalDialogComponent;
  @ViewChild('modalPassword') modalPassword!: ModalDialogComponent;
  @ViewChild('deleteModal') deleteModal!: ModalDialogComponent;

  search: string = "";
  selected: EmployeeUser = new EmployeeUser();

  public actions: DottedDropdownAction[] = [];
  public modalExtraButtons: DottedDropdownAction[] = [];
  public validationErrorMessage: string = "";
  public areDetailsValid: boolean = true;
  public arePasswordDetailsValid: boolean = true;
  public data: EmployeeUser[] = [];
  public employeeTypes = [
    //{ display: 'Captain', value: 'Captain' },
    { display: 'Hostess', value: 'Hostess_A' },
    { display: 'Admin', value: 'Director' },
    //{ display: 'Manager', value: 'Manager' },
    //{ display: 'Hostess_B', value: 'Hostess_B' },
    //{ display: 'Chef', value: 'Chef' },
    //{ display: 'Parker', value: 'Parker' },
    //{ display: 'Server', value: 'Server' },
    //{ display: 'Admin', value: 'Admin' },
    //{ display: 'Waiter', value: 'Waiter' },
    //{ display: 'Hostess', value: 'Hostess' },
    //{ display: 'FrontDesk', value: 'FrontDesk' },
    { display: 'Viewer', value: 'Viewer' },
    //{ display: 'PR', value: 'PR' },
  ];

  constructor(
    private translate: TranslateService,
    private api: SupportApiService,
    private store: Store,
    private localStorageService: LocalStorageService) {
  }

  ngOnInit(): void {
    this.loadActions();
    this.refreshData();
  }

  private refreshData() {
    this.api
      .getForRestaurant(parseInt(this.localStorageService.getRestaurantId() + ""))
      .pipe(first())
      .subscribe((resp) => {
        this.data = resp.sort((a, b) => a.username.localeCompare(b.username));
      });
  }

  loadActions = async () => {
    const justToLoadTranslations = await firstValueFrom(this.translate.get('report.status.completed'));
    this.actions = [
      { name: this.translate.instant('common.buttons.edit'), color: 'default', action: (context: EmployeeUser) => this.edit(context) },
      { name: this.translate.instant('common.buttons.delete'), color: 'danger', action: (context: EmployeeUser) => this.showDeleteModal(context) }
    ];
  }

  setModalExtraActions() {
    this.modalExtraButtons = [
      { name: this.translate.instant('employees.changePassword'), color: 'danger', action: () => this.showChangePasswordModal() },
    ];
  }

  clearSearch() {
    this.search = "";
  }

  showDeleteModal(context: EmployeeUser) {
    this.validationErrorMessage = "";
    this.selected = { ...context };
    this.deleteModal.show();
  }

  showAddModal() {
    this.validationErrorMessage = "";
    this.modalExtraButtons = [];
    this.selected = new EmployeeUser();
    this.selected.mail = "xxxxxxxx@xxxxxx.xxx";
    this.selected.phone = "xxxxxxxxxxx";
    this.modal.show();
  }

  edit(context: EmployeeUser): void {
    this.validationErrorMessage = "";
    this.selected = { ...context };
    this.setModalExtraActions();
    this.modal.show();
  }

  showChangePasswordModal() {
    this.validationErrorMessage = "";
    this.arePasswordDetailsValid = true;
    this.modal.hide();
    this.selected = { ...this.data.find(e => e.id == this.selected.id)! };
    this.selected.password = "";
    this.modalPassword.show();
  }

  modalPasswordClosed(result: boolean) {
    if (result == false) {
      this.modalPassword.hide();
      return;
    }

    this.updatePasswordValidity();

    if (this.arePasswordDetailsValid == false) {
      return;
    }

    this.updateEmployee(true);
  }

  modalClosed(result: boolean): void {
    if (result == false) {
      this.modal.hide();
      return;
    }

    this.updateValidity();

    if (this.areDetailsValid == false) {
      return;
    }

    var isNew = Common.isNullOrEmpty(this.selected.id);
    if (isNew) {
      this.trimEmployeeFields();
      this.selected.restaurantId = this.localStorageService.getRestaurantId() + "";
      this.api
        .createEmployee(this.selected)
        .pipe(first())
        .subscribe({ 
          next: (resp) => {
            this.refreshData();
            this.modal.hide();
          },
          error: () => { 
            this.store.dispatch({ type: AppActions.showAlert.type, alert: this.translate.instant('messages.somethingWrongHappened') }); 
          } 
        }
      )
    } else {
      this.updateEmployee();
    }
  }

  deleteModalClosed(ok: boolean) {
    if (ok == false) {
      return;
    }

    this.api
      .deleteEmployee(this.selected.id)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          this.refreshData();
          this.modal.hide();
          this.invalidateUserSession(this.selected.id);
        },
        error: () => { 
          this.store.dispatch({ type: AppActions.showAlert.type, alert: this.translate.instant('messages.somethingWrongHappened') }); 
        } 
      });
  }

  async invalidateUserSession(userId: string) {
    this.api
      .invalidateSession(userId)
      .pipe(first())
      .subscribe((resp) => {
        console.log("Session invalidated!");
      });
  }

  private trimEmployeeFields() {
    this.selected.name = this.selected.name?.trim() ?? "";
    this.selected.surname = this.selected.surname?.trim() ?? "";
    this.selected.password = this.selected.password?.trim() ?? "";
    this.selected.username = this.selected.username?.trim() ?? "";
    this.selected.mail = this.selected.mail?.trim() ?? "";
    this.selected.phone = this.selected.phone?.trim() ?? "";
  }

  private updateEmployee(invalidateSession = false) {
    this.trimEmployeeFields();

    this.api
      .editEmployee(this.selected)
      .pipe(first())
      .subscribe({
          next: (resp) => {
            this.refreshData();
            this.modal.hide();
            this.modalPassword.hide();
            if (invalidateSession) {
              this.invalidateUserSession(this.selected.id);
            }
        },
        error: () => { 
          this.store.dispatch({ type: AppActions.showAlert.type, alert: this.translate.instant('messages.somethingWrongHappened') }); 
        }         
      });
  }

  private updateValidity() {
    // TODO: validate email address

    if (this.selected == null) {
      this.validationErrorMessage = this.translate.instant('common.requiredFields');
      this.areDetailsValid = false;
      return;
    }

    this.validationErrorMessage = "";

    if (!this.isPasswordValid(this.selected.password)) {
      this.validationErrorMessage = this.translate.instant('employees.errorMessage.invalidPassword');
    }

    if (this.hasRestrictedSymbols(this.selected.username) ||
      this.hasRestrictedSymbols(this.selected.password) ||
      this.hasRestrictedSymbols(this.selected.mail) ||
      this.hasRestrictedSymbols(this.selected.phone) ||
      this.hasRestrictedSymbols(this.selected.surname) ||
      this.hasRestrictedSymbols(this.selected.name)
    ) {
      this.validationErrorMessage = this.translate.instant('employees.errorMessage.restrictedSymbols');
    }

    var isNew = Common.isNullOrEmpty(this.selected.id);

    if (isNew && (
      Common.isNullOrEmpty(this.selected.username) ||
      Common.isNullOrEmpty(this.selected.password)
    )) {
      this.validationErrorMessage = this.translate.instant('common.requiredFields');
    }

    if (isNew && this.data.find(c => c.username == this.selected.username) != null) {
      this.validationErrorMessage = this.translate.instant('common.nameIsUsed');
    }

    if (Common.isNullOrEmpty(this.selected.name) ||
      Common.isNullOrEmpty(this.selected.surname)) {
      this.validationErrorMessage = this.translate.instant('common.requiredFields');
    } else if (this.data.find(c => c.id != this.selected.id && c.name == this.selected.name && c.surname == this.selected.surname) != null) {
      this.validationErrorMessage = this.translate.instant('common.nameIsUsed');
    }

    this.areDetailsValid = Common.isNullOrEmpty(this.validationErrorMessage);
  }

  private updatePasswordValidity() {
    this.validationErrorMessage = "";

    if (!this.isPasswordValid(this.selected.password)) {
      this.validationErrorMessage = this.translate.instant('employees.errorMessage.invalidPassword');
    }

    if (Common.isNullOrEmpty(this.selected.password)
    ) {
      this.validationErrorMessage = this.translate.instant('common.requiredFields');
    }

    if (this.hasRestrictedSymbols(this.selected.password)
    ) {
      this.validationErrorMessage = this.translate.instant('employees.errorMessage.restrictedSymbols');
    }

    this.arePasswordDetailsValid = Common.isNullOrEmpty(this.validationErrorMessage);
  }

  private isPasswordValid(password: string) {
    if (password == null) {
      return false;
    }

    if (this.hasRestrictedSymbols(password)) {
      return false;
    }

    if (password.trim().length < 4) {
      return false
    }

    return true;
  }

  private hasRestrictedSymbols(text: string): boolean {
    if (text == null) return false;

    return text.indexOf('"') != -1 || 
      text.indexOf("'") != -1 || 
      text.indexOf("--") != -1 || 
      text.indexOf("=") != -1 || 
      text.indexOf("*") != -1 || 
      text.indexOf("`") != -1 || 
      text.indexOf("(") != -1 || 
      text.indexOf(")") != -1 || 
      text.indexOf("#") != -1;
  }
}
